import React from "react"
import "./style.css"
const OrangeDot = (props) => {
  return <div className={`orange-dot ${props.className}`}></div>
}

export default OrangeDot
